import React from "react";
import {Box, Stack} from "@mantine/core";
import FormCheckboxInput from "../../checkboxInput/FormCheckboxInput";
import classes from "./OtherDetails.module.css";
import SectionWrapper from "../../section/SectionWrapper";
import {useArticleDetailsFormContext} from "../../ModalArticle";
import {ArticleDetails} from "../../../../../../interfaces/response/ArticleDetails";

interface OtherDetailsProps {
    article: ArticleDetails
}

export default function OtherDetails({article}: OtherDetailsProps) {
    return (
        <Box className={classes.root}>
            <SectionWrapper title="Marketplace">
                <Stack gap={'sm'}>
                    <FormCheckboxInput
                        label={"Mediaworld"}
                        formInfo={{formLabel: "MARKETPLACE - FLAG Mediaworld", formContext: useArticleDetailsFormContext}}
                    />
                    <FormCheckboxInput
                        label={"Leroy Merlin"}
                        formInfo={{formLabel: "MARKETPLACE - FLAG Leroy Merlin", formContext: useArticleDetailsFormContext}}
                    />
                    <FormCheckboxInput
                        label={"Ebay"}
                        formInfo={{formLabel: "MARKETPLACE - FLAG Ebay", formContext: useArticleDetailsFormContext}}
                    />
                    <FormCheckboxInput
                        label={"Kelkoo"}
                        formInfo={{formLabel: "MARKETPLACE - FLAG Kelkoo", formContext: useArticleDetailsFormContext}}
                    />
                    <FormCheckboxInput
                        label={"ePrice"}
                        formInfo={{formLabel: "MARKETPLACE - FLAG ePrice", formContext: useArticleDetailsFormContext}}
                    />
                </Stack>
            </SectionWrapper>
        </Box>
    );
}